import React from 'react';
import '../login/login.css'; 
import { Link } from 'react-router-dom'; 

const Register = () => {

  return (
    <div className='login-wrapper'>
      <div className='login-container'>

        <div className='login-boxes login-left'>
          {/* Image/graphic area */}
        </div>

        <div className='login-boxes login-right'>
          <h2 className='login-heading'>CREATE YOUR ACCOUNT</h2>
          
          <div style={{
              width: '85%', 
              textAlign: 'center', 
              padding: '20px', 
              backgroundColor: '#f9f9f9', 
              borderRadius: '8px', 
              border: '1px solid #eee',
              marginBottom: '20px'
          }}>
            <p style={{
                fontSize: '16px', 
                color: '#333', 
                lineHeight: '1.6',
                margin: '0 0 15px 0'
            }}>
              নতুন রেজিস্ট্রেশন বন্ধ আছে।
            </p>
            
            {/* Contact Button with Mailto Link */}
            <a 
              href="mailto:aronno@twsairinternational.tech"
              style={{
                display: 'inline-block',
                backgroundColor: '#3498db',
                color: 'white',
                textDecoration: 'none',
                padding: '10px 20px',
                borderRadius: '5px',
                fontSize: '14px',
                fontWeight: 'bold',
                transition: 'background 0.3s'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#2980b9'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#3498db'}
            >
              Contact Admin
            </a>
          </div>
          
          <Link className='register-link' to="/login">Login With Your Account</Link>
        </div>

      </div>
    </div>
  )
}

export default Register;